module.exports = __webpack_public_path__ + "static/media/springboot.449e8efb.svg";